document.addEventListener('DOMContentLoaded', () => {
  const dropZone = document.getElementById('firekultur-drop-zone');
  const fileInput = document.getElementById('firekultur-file');
  const uploadButton = document.getElementById('firekultur-upload-button');
  const previewContainer = document.getElementById('firekultur-preview-container');
  const previewThumbnail = document.getElementById('firekultur-preview-thumbnail');
  const fileNameDisplay = document.getElementById('firekultur-file-name');
  const keyInput = document.getElementById('firekultur-key-input');
  const decryptKeyInput = document.getElementById('firekultur-decrypt-key');
  const imageContainer = document.getElementById('firekultur-image-container');
  const decryptImageButton = document.getElementById('firekultur-decrypt-image');
  const encryptImageButton = document.getElementById('firekultur-encrypt-image');
  const displayedImage = document.getElementById('firekultur-displayed-image');
  const downloadImageButton = document.getElementById('firekultur-download-image');
  const startOverButton = document.getElementById('firekultur-start-over');
  const loadingSpinner = document.getElementById('firekultur-loading');
  const errorMessage = document.getElementById('firekultur-error-message');
  const animationMode = document.querySelector('.firekultur-decryptor-section').dataset.animationMode || 'loading';

  if (!dropZone || !fileInput || !uploadButton || !previewContainer || !previewThumbnail || !fileNameDisplay || 
      !keyInput || !decryptKeyInput || !imageContainer || !decryptImageButton || !encryptImageButton || 
      !displayedImage || !downloadImageButton || !startOverButton || !loadingSpinner || !errorMessage) {
    console.error('Required elements not found');
    return;
  }

  if (typeof Math.seedrandom !== 'function') {
    console.error('Seedrandom library not loaded');
    showError('Decryption library failed to load. Please refresh the page.');
    return;
  }

  const allowedTypes = ['image/png', 'image/jpeg', 'image/gif'];
  let originalImageDataUrl = null;
  let encryptedImageDataUrl = null;
  let isDecrypted = false;
  let downloadCount = 1;
  let pixelOrder = [];

  dropZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropZone.classList.add('dragover');
  });

  dropZone.addEventListener('dragleave', () => {
    dropZone.classList.remove('dragover');
  });

  dropZone.addEventListener('drop', (e) => {
    e.preventDefault();
    dropZone.classList.remove('dragover');
    handleFileSelection(e.dataTransfer.files[0]);
  });

  fileInput.addEventListener('change', () => {
    if (fileInput.files.length > 0) {
      handleFileSelection(fileInput.files[0]);
    }
  });

  uploadButton.addEventListener('click', (e) => {
    e.preventDefault();
    if (encryptedImageDataUrl) {
      handleFileUpload(encryptedImageDataUrl);
    } else {
      showError('Please choose a file first!');
    }
  });

  decryptImageButton.addEventListener('click', () => {
    if (!encryptedImageDataUrl || !decryptKeyInput.value) {
      showError('Upload an encrypted image and enter a key first!');
      return;
    }
    decryptImage();
  });

  encryptImageButton.addEventListener('click', () => {
    if (!originalImageDataUrl || !decryptKeyInput.value) {
      showError('No decrypted image or key available!');
      return;
    }
    encryptImage();
  });

  downloadImageButton.addEventListener('click', () => {
    downloadImage();
  });

  startOverButton.addEventListener('click', () => {
    resetPage();
  });

  function loadRandomCover() {
    const covers = document.querySelectorAll('.firekultur-image-container img.cover-loading[data-random="true"]');
    console.log('loadRandomCover running, covers found:', covers.length);

    if (covers.length === 0) return;

    const randomDuration = () => Math.random() * 1000 + 1500; // 1500-2500ms

    covers.forEach(img => {
      if (img.hasAttribute('data-error')) {
        console.warn(`Skipping ${img.alt}: Missing files`);
        return;
      }

      const blurrSrc = img.getAttribute('data-blurr') || img.src;
      const highResSrc = img.getAttribute('data-highres') || img.src;

      const loadBlurr = () => {
        const blurr = new Image();
        blurr.src = blurrSrc;
        blurr.onload = () => {
          img.classList.add('random-fading');
          const fadeTime = randomDuration();
          setTimeout(() => {
            img.src = blurrSrc;
            img.classList.remove('random-fading');
            loadHighRes();
          }, fadeTime);
        };
      };

      const loadHighRes = () => {
        const highRes = new Image();
        highRes.src = highResSrc;
        highRes.onload = () => {
          img.classList.add('random-tuning');
          const tuneTime = randomDuration();
          setTimeout(() => {
            img.src = highResSrc;
            img.classList.remove('random-tuning');
            img.classList.add('random-finalizing');
            const finalTime = randomDuration() / 2; // 750-1250ms
            setTimeout(() => {
              img.classList.remove('random-finalizing');
              img.setAttribute('loaded', 'true');
            }, finalTime);
          }, tuneTime);
        };
      };

      img.style.opacity = '1';
      loadBlurr();
    });
  }

  function handleFileSelection(file) {
    if (!allowedTypes.includes(file.type)) {
      showError('Invalid format. Use PNG, JPG, JPEG, or GIF.');
      return;
    }

    loadingSpinner.style.display = 'block';
    errorMessage.style.display = 'none';

    const reader = new FileReader();
    reader.onload = (e) => {
      encryptedImageDataUrl = e.target.result;
      fileNameDisplay.textContent = `Selected: ${file.name}`;
      previewThumbnail.src = encryptedImageDataUrl;
      previewContainer.style.display = 'block';
      uploadButton.style.display = 'inline-block';
      loadingSpinner.style.display = 'none';
    };
    reader.onerror = () => {
      showError('Error reading file.');
      loadingSpinner.style.display = 'none';
    };
    reader.readAsDataURL(file);
  }

  function handleFileUpload(dataUrl) {
    loadingSpinner.style.display = 'block';
    displayedImage.src = dataUrl;
    imageContainer.style.display = 'block';
    previewContainer.style.display = 'none';
    uploadButton.style.display = 'none';
    keyInput.style.display = 'block';
    loadingSpinner.style.display = 'none';
  }

  function decryptImage() {
    loadingSpinner.style.display = 'block';
    const img = new Image();
    img.src = encryptedImageDataUrl;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      const key = decryptKeyInput.value;
      const seed = key.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
      const unscrambledPixels = unscramblePixels(pixels, seed);

      ctx.putImageData(new ImageData(unscrambledPixels, canvas.width, canvas.height), 0, 0);
      originalImageDataUrl = canvas.toDataURL('image/png');
      applyAnimation(() => {
        displayedImage.src = originalImageDataUrl;
        isDecrypted = true;
        loadingSpinner.style.display = 'none';
      });
    };
    img.onerror = () => {
      showError('Error loading image for decryption.');
      loadingSpinner.style.display = 'none';
    };
  }

  function encryptImage() {
    loadingSpinner.style.display = 'block';
    const img = new Image();
    img.src = originalImageDataUrl;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      const key = decryptKeyInput.value;
      const seed = key.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
      const scrambledData = scramblePixels(pixels, seed);

      pixelOrder = scrambledData.order;
      ctx.putImageData(new ImageData(scrambledData.pixels, canvas.width, canvas.height), 0, 0);
      encryptedImageDataUrl = canvas.toDataURL('image/png');
      applyAnimation(() => {
        displayedImage.src = encryptedImageDataUrl;
        isDecrypted = false;
        loadingSpinner.style.display = 'none';
      });
    };
    img.onerror = () => {
      showError('Error loading image for encryption.');
      loadingSpinner.style.display = 'none';
    };
  }

  function scramblePixels(pixels, seed) {
    const pixelArray = new Uint8ClampedArray(pixels);
    const length = pixelArray.length;
    const order = Array.from({ length }, (_, i) => i);
    const rng = new Math.seedrandom(seed.toString());

    for (let i = length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [order[i], order[j]] = [order[j], order[i]];
    }

    const scrambled = new Uint8ClampedArray(length);
    for (let i = 0; i < length; i++) {
      scrambled[i] = pixelArray[order[i]];
    }

    return { pixels: scrambled, order };
  }

  function unscramblePixels(pixels, seed) {
    const pixelArray = new Uint8ClampedArray(pixels);
    const length = pixelArray.length;
    const order = Array.from({ length }, (_, i) => i);
    const rng = new Math.seedrandom(seed.toString());

    for (let i = length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [order[i], order[j]] = [order[j], order[i]];
    }

    const unscrambled = new Uint8ClampedArray(length);
    for (let i = 0; i < length; i++) {
      unscrambled[order[i]] = pixelArray[i];
    }

    return unscrambled;
  }

  function applyAnimation(callback) {
    if (animationMode === 'simple') {
      displayedImage.classList.add('firekultur-scramble');
      setTimeout(() => {
        callback();
        displayedImage.classList.remove('firekultur-scramble');
      }, 600);
    } else {
      loadRandomCover();
      setTimeout(callback, 2500); // Match longest duration
    }
  }

  function downloadImage() {
    if (!displayedImage.src) {
      showError('No image to download!');
      return;
    }

    const fileName = fileNameDisplay.textContent.replace('Selected: ', '');
    const key = decryptKeyInput.value;
    const extension = fileName.split('.').pop();
    const baseName = fileName.replace(`.${extension}`, '');
    const newFileName = `${baseName}_${key}_${downloadCount}.${extension}`;

    const link = document.createElement('a');
    link.href = displayedImage.src;
    link.download = newFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    downloadCount++;
  }

  function resetPage() {
    originalImageDataUrl = null;
    encryptedImageDataUrl = null;
    isDecrypted = false;
    downloadCount = 1;
    pixelOrder = [];
    fileNameDisplay.textContent = '';
    previewThumbnail.src = '';
    previewContainer.style.display = 'none';
    uploadButton.style.display = 'none';
    keyInput.style.display = 'none';
    imageContainer.style.display = 'none';
    errorMessage.style.display = 'none';
    decryptKeyInput.value = '';
  }

  function showError(message) {
    errorMessage.textContent = message;
    errorMessage.style.display = 'block';
    loadingSpinner.style.display = 'none';
  }
});